/**
* 班级任务与个人的列表
*/
<template>
    <span>
        <a @click="openmodel()">详情</a>
        <a-modal :visible="visible" :width="1280" title="任务发布情况详情" @ok="okmodel" @cancel="cancelmodel">
            <squadlist @getsquad="getsquad" v-bind:itemdata="itemdata" buttinname="添加"></squadlist>
            <a-divider></a-divider>

            <div>
                <a-table :dataSource="squadlist" :rowKey="item => item.id" :pagination="pageinfo" :loading="loading"
                    @change="onPaginationChange" bordered>
                    <a-table-column key="gradename" title="年级" data-index="grade_name" />
                    <a-table-column key="campusname" title="校区" data-index="campus_name" />
                    <a-table-column key="name" title="班级" data-index="name" />
                    <a-table-column key="create_time" title="开始时间">
                        <template slot-scope="item">
                            {{ moment(item.start_time * 1000).format('lll') }}
                        </template>
                    </a-table-column>
                    <a-table-column key="end_time" title="结束时间">
                        <template slot-scope="item">
                            {{ moment(item.end_time * 1000).format('lll') }}
                        </template>
                    </a-table-column>
                    <a-table-column key="action" title="操作">
                        <template slot-scope="text, record">
                            <span>
                                <squadusermodel v-bind:itemdata="record" v-bind:mission_id="itemdata.id"></squadusermodel>
                                <a-button @click="squadmissiondell({ squad_id: record.squad_id, mission_id: itemdata.id })"
                                    class="active_btn" size="small" type="link">删除任务
                                </a-button>
                                <!-- <a @click="shengchengmission(record.id)">查看</a> -->
                            </span>
                    </template>
                </a-table-column>
                <!-- <a-table-column key="type" title="班型">
                        <template slot-scope="item">
                            <span v-if="item.type==0">培优班</span>
                            <span v-if="item.type==1">提高班</span>
                            <span v-if="item.type==2">英才班</span>
                                <span v-if="item.type==3">1对1VIP班</span>
                        </template>
                    </a-table-column> -->
                <!-- <a-table-column key="opening" title="开班状态">
                        <template slot-scope="item">
                            <span v-if="item.opening==0">未开班</span>
                            <span v-if="item.opening==1">已开班</span>
                                <span v-if="item.opening==2">已结班</span>
                            </template>
                        </a-table-column> -->

                </a-table>
                <div>总共{{ pageinfo.total }}条数据</div>
            </div>

        </a-modal>
    </span>
</template>
<script>
import moment from "moment";
import squadusermodel from '@/views/orgpublish/squadusermodel.vue';
import squadlist from '@/views/orgpublish/squadlist.vue';
export default {
    components: { squadusermodel, squadlist },
    props: {
        itemdata: {}
    },
    data() {
        return {
            data: [],
            pageinfo: {
                total: 1,
                current: 1,
                pageSize: 10
            },
            squadlist: [],
            loading: false,
            visible: false,
            squad_ids: [],
            mission_id: undefined,
        };
    },
    mounted() {

    },
    computed: {
        rowSelection() {
            return {
                onChange: (selectedRowKeys, selectedRows) => {
                    selectedRows;
                    //  this.squad_id = selectedRowKeys;
                    // console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
                },

            };
        },
    },
    methods: {
        getTableList() {
            this.loading = true;
            this.$axios
                .post("/api/BasicMission/getsquadlistbymission", {
                    data: {
                        mission_id: this.itemdata.id,
                    },
                    pageinfo: this.pageinfo
                })
                .then(res => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定"
                        });
                        this.squadlist = null;
                    } else {
                        this.squadlist = res.data.data;
                        this.pageinfo = res.data.pageinfo;
                    }
                })
                .catch(err => {
                    console.error(err);
                }).finally(() => {
                    this.loading = false;
                })
        },
        getsquad(data) {

            this.squad_ids = data.squad_id;
            this.mission_id = data.itemdata.id
            console.log(this.mission_id)
            this.squadaddmission();
        },

        //补发班级任务
        squadaddmission() {
            this.spinning = true;
            this.$axios
                .post("/api/BasicMission/bufasquadmission", {
                    data: {
                        'mission_id': this.mission_id,
                        'squad_ids': this.squad_ids,
                    },
                })
                .then((res) => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定",
                        });
                        this.spinning = false;
                    } else {

                        if (res.data.lostsquadlist.length > 0) {

                            this.$notification.warning({
                                message: '此任务未完全生成',
                                description: "此任务有" + res.data.lostsquadlist.length +
                                    "个班级没有生成成功，因为班级内已经有相同的试卷",
                                duration: 0,
                            });
                        }

                        this.$message.success("操作成功");
                        this.getTableList();
                        this.spinning = false;
                    }
                })
                .catch((err) => {
                    console.error(err);
                });
        },

        squadmissiondell(data) {
            let _this = this;
            _this.$confirm({
                title: "删除任务",
                content: "确认删除当前任务吗?删除当前任务将会删除学生所做的所有作业。",
                okText: "确认",
                cancelText: "取消",
                onOk: function () {
                    _this.$axios
                        .post("/api/OrgSquad/delsquadmission", {
                            data
                        })
                        .then(res => {
                            if (res.code != 200) {
                                _this.$error({
                                    title: "错误",
                                    content: res.msg,
                                    okText: "确定"
                                });
                            } else {
                                _this.getTableList();
                            }
                        })
                        .catch(err => {
                            console.error(err);
                        });
                }
            });
        },

        openmodel() {
            this.visible = true;
            this.getTableList();
        },
        okmodel() {
            this.visible = false;
        },
        cancelmodel() {
            this.visible = false;
        },

        onPaginationChange(item) {
            this.pageinfo.current = item.current;
            this.getTableList();
        },

        moment
    }
};
</script>
<style>
.active_btn {
    margin-left: 5px;
}
</style>
